import React, {memo} from 'react';
import {View, StyleSheet, Text} from 'react-native';
import {IconClose} from '@redlink/components/atoms/iconClose';
import {IconPassed} from '@redlink/components/atoms/iconPassed';
import {Space} from '@redlink/components/atoms/space';
import {light as colors} from '@redlink/assets/styles/colors';

export const Alert = memo(({style, options: {type}, message, close}) => {
    const icon =
        type === 'error' ? (
            <IconClose color={colors.white}/>
        ) : (
            <IconPassed color={colors.white}/>
        );
    return (
        <View style={[styles.container, styles[`${type}Container`], style]}>
            {icon}
            <Space size={8}/>
            <Text style={styles.messageText}>{message}</Text>
        </View>
    );
});

const styles = StyleSheet.create({
    container: {
        minWidth: 300,
        maxWidth: 400,
        borderRadius: 5,
        padding: 24,
        flexDirection: 'row',
        alignItems: 'center',
    },
    errorContainer: {
        backgroundColor: colors.red1,
    },
    successContainer: {
        backgroundColor: colors.green2,
    },
    infoContainer: {
        backgroundColor: colors.blue1,
    },
    messageText: {
        color: colors.white,
        fontWeight: 'bold',
        fontSize: 14,
    },
});
